import Success from 'assets/icons/success.svg';
import Error from 'assets/icons/warning.svg';

export const TYPES = {
  success: 'success',
  error: 'error',
};

export const icons = {
  [TYPES.success]: Success,
  [TYPES.error]: Error,
};

export const defaultSuccessModalData = {
  title: {
    [TYPES.success]: 'Заявка отправлена!',
    [TYPES.error]: 'К сожалению, заявка не отправлена',
  },
  description: {
    [TYPES.success]: 'Мы свяжемся с тобой в ближайшее время',
    [TYPES.error]: 'Попробуйте снова',
  },
};
